import * as React from "react";

/**
 * Butter ("now") source chip that links a note, decision or action back to the transcript moment it came from. Every AI-generated line must carry one (FR-M7).
 */
export interface TimestampProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  /** "12:04" or "1:02:10" */
  time: string;
  /** The chip whose source is currently shown */
  active?: boolean;
}

export function Timestamp({ time, active, className, ...rest }: TimestampProps): JSX.Element {
  return (
    <button type="button" className={["gk-ts", active && "gk-ts--active", className].filter(Boolean).join(" ")} {...rest}>
      {time}
    </button>
  );
}
